import React, { useEffect, useState } from "react"
import { FastField, useFormikContext } from "formik"
import ShareholderModal from "./ShareholderModal"
import Shareholder from "./Shareholder"
import Loader from "../../../Loader"
import FormError from "../../../formError"

const Shareholders = () => {
  const { values, errors, touched, handleChange, setFieldValue } =
    useFormikContext()
  const [shareholders, setShareholders] = useState([])
  const [popup, setPopup] = useState(false)
  const [isLoading, setIsLoading] = useState(true)

  const getShareholders = () => {
    const storedData = JSON.parse(localStorage.getItem("formDataArray")) || []
    setIsLoading(false)
    setShareholders(storedData)
  }

  useEffect(() => {
    getShareholders()
  }, [])

  const openPopUp = ()=> {
    setPopup(true)
    setFieldValue("isShareholder", "Shareholder Information")
  }
  const hidePopup = () => {
    setPopup(false)
  }

  if (isLoading) return <Loader width="50" color="#46b839" />

  return (
    <>
      <div className="row">
        <div className="col text-right">
          <button
            className="btn cursor text-secure"
            onClick={() =>
              openPopUp(
                setFieldValue("isShareholder", "Shareholder Information")
              )
            }
            type="button"
          >
            + Add New Shareholder
          </button>
          <FormError
            touched={touched.isShareholder}
            message={errors.isShareholder}
          />
        </div>
      </div>

      <div className="">
        {shareholders?.map((shareholder, index) => (
          <Shareholder data={shareholder} key={index} />
        ))}
      </div>

      <ShareholderModal
        show={popup}
        closePopup={() => hidePopup()}
        fetchShareholders={getShareholders}
      />
    </>
  )
}
export default Shareholders
